import React from 'react';
import { X } from 'lucide-react';

function fmtCur(n) {
  return `₹${parseFloat(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function fmtCurShort(n) {
  const v = parseFloat(n || 0);
  return `₹${v.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

function formatDate(d) {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return d; }
}

export default function InvoiceReceiptModal({ invoice, onClose }) {
  if (!invoice) return null;
  const items = invoice.items ?? [];

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="bg-white dark:bg-gray-900 w-full sm:max-w-md sm:rounded-xl shadow-2xl flex flex-col max-h-[90vh]">
        <div className="flex items-start justify-between px-4 pt-4 pb-3 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div>
            <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {invoice.supplier_name || invoice.shop_name || 'Invoice'}
            </h2>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {invoice.pos_bill_number ? `Bill #${invoice.pos_bill_number}` : 'No bill number'} · {formatDate(invoice.invoice_date)}
            </p>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 px-4 py-3">
          {items.length === 0 ? (
            <p className="text-xs text-gray-400 py-4 text-center">No items found</p>
          ) : (
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-gray-100 dark:border-gray-800">
                  <th className="text-left pb-2 font-medium text-gray-500 dark:text-gray-400">Product</th>
                  <th className="text-right pb-2 font-medium text-gray-500 dark:text-gray-400">Qty</th>
                  <th className="text-right pb-2 font-medium text-gray-500 dark:text-gray-400">Rate</th>
                  <th className="text-right pb-2 font-medium text-gray-500 dark:text-gray-400">Total</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50 dark:divide-gray-800">
                {items.map((it, i) => (
                  <tr key={i}>
                    <td className="py-1.5 text-gray-800 dark:text-gray-200">{it.product_name || '—'}</td>
                    <td className="py-1.5 text-right text-gray-600 dark:text-gray-400">{it.qty}</td>
                    <td className="py-1.5 text-right text-gray-600 dark:text-gray-400">{fmtCurShort(it.unit_price)}</td>
                    <td className="py-1.5 text-right font-medium text-gray-900 dark:text-gray-100">{fmtCurShort(it.item_total)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t border-gray-200 dark:border-gray-700">
                  <td colSpan={3} className="pt-2 font-semibold text-gray-700 dark:text-gray-300">Total</td>
                  <td className="pt-2 text-right font-bold text-gray-900 dark:text-gray-100">{fmtCur(invoice.total_amount)}</td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>

        <div className="px-4 pb-4 pt-3 border-t border-gray-100 dark:border-gray-800 flex-shrink-0">
          <button onClick={onClose}
            className="w-full py-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
